import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { NgxMaterialTimepickerTheme } from 'ngx-material-timepicker';
import { changeState, growTextAnimation } from '../../../helpers/animation';
import { EmittedDateRangeControl } from '../../../helpers/crud/edit/form-control/form-control-date-range-selector/form-control-date-range-selector.component';
import { FormControlDiffusionSettingsComponent } from '../../../helpers/crud/edit/form-control/form-control-diffusion-settings/form-control-diffusion-settings.component';
import { FormControl } from '../../../helpers/crud/edit/form-control/form-control.model';
import { FormGroupHelper } from '../../../helpers/crud/edit/form-control/form-group-helper';
import { AlertService } from '../../../services/alert/alert.service';
import { TitleService } from '../../../services/title/title.service';
import { MenuContextService } from '../../layout/services/menu-context.service';
import { FormatTypeService } from '../../spots/services/format-type.service';
import { SpotService } from '../../spots/services/spot.service';
import {
    PerdiodTypeEnum,
    PeriodTypeCalculationDate,
    PeriodTypeTranslate,
} from '../periodType.enum';
import { PrivateCampaign } from '../private-campaign.model';
import { CampaignService, WVDiffusion } from '../services/campaign.service';
import { DateTime } from 'luxon';
import { Crisp } from 'crisp-sdk-web';
import { WaitingService } from '../../layout/waiting/waiting.service';

// export const MY_FORMATS = {
// 	parse: {
// 		dateInput: 'DD/MM/YYYY',
// 	},
// 	display: {
// 		dateInput: 'DD/MM/YYYY',
// 		monthYearLabel: 'MMM YYYY',
// 		dateA11yLabel: 'DD/MM/YYYY',
// 		monthYearA11yLabel: 'MMMM YYYY',
// 	},
// };

@Component({
    selector: 'app-create',
    templateUrl: './create.component.html',
    // providers: [provideMomentDateAdapter(MY_FORMATS)],
    styleUrls: ['./create.component.scss'],
    animations: [growTextAnimation],
})
export class CreateComponent implements OnInit {
    PerdiodTypeEnum = PerdiodTypeEnum;
    PeriodTypeTranslate = PeriodTypeTranslate;
    PeriodTypeCalculationDate = PeriodTypeCalculationDate;

    pickerTheme: NgxMaterialTimepickerTheme = {
        dial: {
            dialBackgroundColor: '#126FE1',
        },
        clockFace: {
            clockHandColor: '#126FE1',
        },
    };

    @ViewChild('diffusionSettings', { static: true })
    diffusionSettings: FormControlDiffusionSettingsComponent;

    public controls: { [key: string]: FormControl };
    public form: UntypedFormGroup;
    public spotIdButtonBool = false;
    public faceId: string;
    public loaded: boolean = false;

    public urlSpotId;
    /**
     * Id of default Diffusion for Wancom campaign
     *
     * **Enable specific mode to create private-campaign**
     *
     * ***need to be passed through JSON URL***
     *
     * - Limit 'Other' date to campaign dates
     * - Remove duration control
     * - Add DiffusionPriority notion
     * - At save create new diffusion
     */
    public defaultDiffId: number;
    public isWancomDiff: boolean = false;
    /**
     * Id of diffusion to edit
     *
     */
    public diffusionId: number;
    public isStaticSpot: boolean;
    // Slide toggle
    public stateWeekDays = false;
    public stateHour = false;
    public stateWeather = false;
    public stateTemperature = false;

    public displayWeather;

    public editMode = false;

    public indexSelected = 0;

    public cState = changeState;
    public animationState = 'initial';

    public dateToRangeControl: { begin: Date; end: Date };

    public today = new Date();
    public startReservation: Date = null;
    public endReservation: Date = null;
    public todayDay;
    public dayUntillWeekEnd;
    public isDeviceisDesktop = false;
    public onlyOneScreen;
    public windowWidth;
    public isNewDiff: boolean = false;
    constructor(
        private readonly title: TitleService,
        protected route: ActivatedRoute,
        private readonly router: Router,
        private readonly formBuilder: UntypedFormBuilder,
        // public diffusionDay$: DiffusionDaysService,
        public campaigns$: CampaignService,
        public alert: AlertService,
        public menuContext$: MenuContextService,
        private readonly spots: SpotService,
        private readonly deviceService: DeviceDetectorService,
        public format$: FormatTypeService,
        private readonly waiting$: WaitingService
    ) {
        setTimeout(() => {
            this.title.next('Créer une campagne privée');
        }, 0);
    }
    public date = DateTime.local();

    public changeState(): void {
        this.cState(this.animationState);
    }

    ngOnInit() {
        if (window.innerWidth <= 900) {
            this.isDeviceisDesktop = false;
        } else {
            this.isDeviceisDesktop = true;
        }
        if (!Crisp.isCrispInjected()) {
            Crisp.configure('7d4a0471-984f-4f44-a5cd-e0ef1ef779b4');
            if(!this.isDeviceisDesktop){
                Crisp.chat.hide();
            }
        } else {
            Crisp.chat.show();
            if(!this.isDeviceisDesktop){
                Crisp.chat.hide();
            }
        }
        const isDesktopDevice = this.deviceService.isDesktop();
        this.windowWidth = window.innerWidth;

        this.changeState();

        this.todayDay = this.today.getDay();
        this.dayUntillWeekEnd = 7 - this.todayDay;

        const name = new FormControl('name');

        // Période
        const beginDate = new FormControl('beginDate').required(
            'Veuillez saisir une date de début'
        );

        const endDate = new FormControl('endDate').required(
            'Veuillez saisir une date de fin'
        );

        // Params
        const weekDays = new FormControl('weekDays');
        const beginHour = new FormControl('beginHour');
        const endHour = new FormControl('endHour');
        const weather = new FormControl('weather');
        const minTemp = new FormControl('minTemp');
        const maxTemp = new FormControl('maxTemp');

        const organizationId = new FormControl('organizationId');
        const spotId = new FormControl('spotId');

        const spotDuration = new FormControl('spotDuration');

        const diffusionPriority = new FormControl('diffusionPriority');

        const isPermanent = new FormControl('isPermanent');

        const loopOverride = new FormControl('loopOverride');

        weekDays.setValue([]);
        organizationId.setValue(this.route.snapshot.paramMap.get('id'));

        this.getUrlParams(diffusionPriority);

        spotId.setValue(null);

        this.controls = {
            name: name,
            beginDate: beginDate,
            endDate: endDate,
            weekDays: weekDays,
            beginHour: beginHour,
            endHour: endHour,
            weather: weather,
            minTemp: minTemp,
            maxTemp: maxTemp,
            organizationId: organizationId,
            spotId: spotId,
            spotDuration: spotDuration,
            diffusionPriority: diffusionPriority,
            isPermanent: isPermanent,
            loopOverride: loopOverride,
        };
        this.form = this.formBuilder.group(this.controls);

        this.format$.formatForMyPark().subscribe((ret: any) => {
            if (ret.length === 1) {
                if (ret[0].screens.length === 1) {
                    this.onlyOneScreen = ret[0].screens[0].id;
                }
            }
        });

        this.getSpotId();
        this.setEndDate(0);

        this.controls.beginDate.setValue(DateTime.local().toISO());

        if (
            this.route.snapshot.queryParams.diffusionId &&
            this.route.snapshot.queryParams.diffusionId != null
        ) {
            this.diffusionId = this.route.snapshot.queryParams.diffusionId;
        }

        this.loadPrivateCampaign();
    }

    /**
     * Si diffusionId, charge la campagne existante
     */
    private loadPrivateCampaign() {
        this.loaded = false;
        if (this.diffusionId) {
            this.editMode = true;

            const waitingId: string = this.waiting$.start();
            this.campaigns$.getPrivateCampaign(this.diffusionId).subscribe({
                next: (campaign: PrivateCampaign) => {
                    this.waiting$.end(waitingId);
                    this.indexSelected = campaign.isPermanent ? 3 : 2;

                    this.controls.isPermanent.setValue(campaign.isPermanent);

                    this.controls.loopOverride.setValue(campaign.loopOverride);

                    this.controls.name.setValue(campaign.name);

                    this.controls.beginDate.setValue(
                        DateTime.fromISO(campaign.beginDate.toString())
                    );
                    this.controls.endDate.setValue(
                        DateTime.fromISO(campaign.endDate.toString())
                    );

                    this.controls.spotDuration.setValue(campaign.spotDuration);

                    if (campaign.weekDays.length > 0) {
                        this.diffusionSettings.isDayFiltered.setValue(true);
                        this.controls.weekDays.setValue(campaign.weekDays);
                    }

                    if (
                        campaign.beginHour != null &&
                        campaign.endHour != null
                    ) {
                        this.diffusionSettings.isHourFiltered.setValue(true);
                        this.controls.beginHour.setValue(campaign.beginHour);
                        this.controls.endHour.setValue(campaign.endHour);

                        //transformation de l'heure en format lisible par le component;
                        let tempBeginHour: string[] =
                            campaign.beginHour.split(':');
                        this.diffusionSettings.beginHourControl.setValue(
                            tempBeginHour[0] + ':' + tempBeginHour[1]
                        );
                        //transformation de l'heure en format lisible par le component;
                        let tempEndHour: string[] = campaign.endHour.split(':');
                        this.diffusionSettings.endHourControl.setValue(
                            tempEndHour[0] + ':' + tempEndHour[1]
                        );
                        // this.diffusionSettings.endHourControl.setValue(campaign.endHour);
                    }

                    if (campaign.weather != null) {
                        this.diffusionSettings.isWeatherFiltered.setValue(true);
                        this.controls.weather.setValue(campaign.weather);
                        if (campaign.weather < 4)
                            this.diffusionSettings.displayWeather = true;
                    }

                    if (campaign.minTemp != null && campaign.maxTemp != null) {
                        this.diffusionSettings.isTempFiltered.setValue(true);
                        this.controls.minTemp.setValue(campaign.minTemp);
                        this.controls.maxTemp.setValue(campaign.maxTemp);
                    }

                    if (campaign.diffusionPriority != null) {
                        this.controls.diffusionPriority.setValue(
                            campaign.diffusionPriority
                        );
                    }
                    this.loaded = true;
                },
                error: (err) => {
                    this.waiting$.end(waitingId);
                    console.error(err);
                    this.loaded = true;
                },
            });
        } else {
            this.loaded = true;
        }
    }

    private getUrlParams(diffusionPriority: FormControl) {
        this.route.queryParams.subscribe((params) => {
            if (params['option']) {
                const faceIdParams = params['option'];

                const faceIdParsed = JSON.parse(faceIdParams);

                this.faceId = faceIdParsed[1].faceId;
                this.urlSpotId = faceIdParsed[0].id;
                this.defaultDiffId = faceIdParsed[1].defaultDiffId;

                if (this.defaultDiffId == null) {
                    this.spots
                        .isStaticSpot(this.urlSpotId)
                        .subscribe((ret: any) => {
                            if (ret) {
                                this.isStaticSpot = true;
                                this.controls.spotDuration.setValue('10');
                            }
                        });
                } else {
                    this.enableWancomDiffMode(diffusionPriority, false);
                }
            }
            if (params['spotId']) {
                this.urlSpotId = params['spotId'];
                this.spots
                    .isStaticSpot(this.urlSpotId)
                    .subscribe((ret: any) => {
                        if (ret) {
                            this.isStaticSpot = true;
                            this.controls.spotDuration.setValue('10');
                        }
                    });
            }

            if (params['DiffToEditId']) {
                this.diffusionId = params['DiffToEditId'];
                this.enableWancomDiffMode(diffusionPriority, true);
            }

            if (params['isNewDiff']) {
                this.isNewDiff = params['isNewDiff'] === 'true';
            }

            if (params['faceId']) {
                this.faceId = params['faceId'];
            }
        });
    }

    private enableWancomDiffMode(
        diffusionPriority: FormControl,
        editMode: boolean
    ) {
        this.isWancomDiff = true;
        this.campaigns$
            .getReservationDates(
                editMode ? this.diffusionId : this.defaultDiffId
            )
            .subscribe((dates) => {
                this.startReservation = dates.startDate;
                this.endReservation = dates.endDate;

                this.controls.beginDate.setValue(this.startReservation, {
                    emitEvent: false,
                });
                this.controls.endDate.setValue(this.endReservation, {
                    emitEvent: false,
                });
            });

        diffusionPriority.required(
            'Veuillez définir un ordre de priorité pour cette diffusion'
        );
    }

    getSpotId() {
        this.route.queryParams.subscribe((params) => {
            if (params['option']) {
                const spotIdParams = params['option'];
                const spotIdParsed = JSON.parse(spotIdParams);
                this.spots.getSpotName(spotIdParsed[0].id).subscribe((spot) => {
                    if (spot.name != null)
                        this.controls.name.setValue(spot.name);
                });

                this.spotIdButtonBool = true;
                this.controls.spotId.setValue(spotIdParsed[0].id);
            }
        });
    }

    setEndDate(periodTypeEnum: PerdiodTypeEnum) {        
        this.changeState();

        const isPermanent: boolean = this.controls.isPermanent.value;

        this.controls.isPermanent.setValue(false);

        switch (periodTypeEnum) {
            case PerdiodTypeEnum.forTheDay:
                this.controls.beginDate.setValue(DateTime.local());
                this.controls.endDate.setValue(
                    DateTime.local().plus({ days: 0 })
                );

                break;

            case PerdiodTypeEnum.forTheWeek:
                this.controls.beginDate.setValue(DateTime.local());
                this.controls.endDate.setValue(
                    DateTime.local().plus({ days: this.dayUntillWeekEnd })
                );
                break;

            case PerdiodTypeEnum.Permanent:
                //On set en 2100 mais masqué
                this.controls.beginDate.setValue(
                    DateTime.local().minus({ days: 1 })
                );
                this.controls.endDate.setValue(
                    DateTime.local().set({
                        year: 2100,
                        day: 1,
                        month: 0,
                        hour: 0,
                        minute: 0,
                        millisecond: 0,
                    })
                );

                // Set l'attribut de diffusion permanente
                this.controls.isPermanent.setValue(true);
                break;

            case PerdiodTypeEnum.Personalized:
                if (isPermanent) {
                    this.controls.beginDate.setValue(DateTime.local());
                    this.controls.endDate.setValue(
                        DateTime.local().plus({ months: 1 })
                    );
                }

                break;

            default:
                break;
        }
    }

    public dateRangeChanged(event: EmittedDateRangeControl): void {
        this.controls.beginDate.setValue(
            new Date(event.begin.year, event.begin.month, event.begin.day, 12)
        );
        this.controls.endDate.setValue(
            new Date(event.end.year, event.end.month, event.end.day, 12)
        );
    }

    /**
     * Création de la campagne privée
     *
     * @param finish `boolean`
     * @returns void
     */
    nextTo(finish: boolean): void {
        if (!this.form.valid) {
            Object.keys(this.form.controls).forEach((key) => {
                if (!this.form.get(key).valid && this.form.get(key).pristine)
                    this.form.get(key).markAsTouched();
            });

            this.form.updateValueAndValidity();
        }

        FormGroupHelper.cleanServerErrors(this.form);
        if (!this.form.valid) {
            return;
        }

        if (
            this.controls.beginHour.value == null &&
            this.controls.endHour.value != null
        ) {
            this.alert.show({
                message: 'Saisir une heure de début de diffusion',
                duration: 2000,
            });
            return;
        }
        if (
            this.controls.beginHour.value != null &&
            this.controls.endHour.value == null
        ) {
            this.alert.show({
                message: 'Saisir une heure de fin de diffusion',
                duration: 2000,
            });
            return;
        }

        if (
            this.controls.beginDate.value &&
            DateTime.isDateTime(this.controls.beginDate.value)
        ) {
            this.controls.beginDate.setValue(
                this.controls.beginDate.value.plus({ hours: 1 })
            );

            this.controls.endDate.setValue(
                this.controls.endDate.value.plus({ hours: 1 })
            );
        }

        if (this.isWancomDiff) {
            this.makeWVDiffusion();
        } else {
            this.makePrivateCampaign(finish);
        }
    }

    private makeWVDiffusion() {
        const wvDiff: WVDiffusion = FormGroupHelper.mapTo<WVDiffusion>(
            this.form
        );

        if (this.editMode) {
            this.editWancomDiff(wvDiff);
        } else {
            this.createWancomDiff(wvDiff);
        }
    }

    private createWancomDiff(wvDiff: WVDiffusion) {
        wvDiff.id = null;
        wvDiff.defaultDiffusionId = this.defaultDiffId;

        this.campaigns$.createDiffusion(wvDiff).subscribe({
            next: () => {
                //Redirect to park
                this.alert.show({
                    message: 'Nouvelle diffusion créée avec succès !',
                    duration: 2000,
                });

                this.router.navigateByUrl(
                    `private-campaign/screens/${this.diffusionId}?editMode=true`
                );
            },
            error: (err) => {
                this.alert.show({
                    message: 'Erreur lors de la création de la diffusion.',
                    duration: 3000,
                });

                console.error(err);
            },
        });
    }

    private editWancomDiff(wvDiff: WVDiffusion) {
        wvDiff.id = this.diffusionId;

        this.campaigns$.editDiffusion(wvDiff).subscribe({
            next: (updatedDiff: WVDiffusion) => {
                this.alert.show({
                    message: 'Paramètres de diffusion modifiés avec succès !',
                    duration: 2000,
                });

                if (this.isNewDiff) {
                    this.router.navigateByUrl(
                        `private-campaign/screens/${this.diffusionId}?editMode=true&faceId=${this.faceId}`
                    );
                } else {
                    this.redirectToMainPage();
                }
            },
            error: (err) => {
                this.alert.show({
                    message:
                        'Erreur lors des changements des paramètres de diffusion.',
                    duration: 3000,
                });

                console.error(err);
            },
        });
    }

    private redirectToMainPage() {
        const endRedirect: string = localStorage.getItem("EndRedirection") ?? 'park';

        localStorage.removeItem("EndRedirection");
        this.router.navigateByUrl(endRedirect);
    }

    /**
     * Create Private Campaign --Wanview normal use case--
     * @param finish is editing of campaign done
     */
    private makePrivateCampaign(finish: boolean) {
        this.loaded = false;

        const item = FormGroupHelper.mapTo<PrivateCampaign>(this.form);

        item.organizationId = this.controls.organizationId.value;
        item.id = this.route.snapshot.queryParams.diffusionId;

        if (this.isNewDiff) {
            item.id = null;
        }

        const waitingId: string = this.waiting$.start();
        this.campaigns$.editPrivateCampaign(item).subscribe({
            next: (result) => {
                this.waiting$.end(waitingId);
                if (!finish) {
                    if (this.controls.spotId.value !== null) {
                        if (this.onlyOneScreen != null) {
                            let faceIds = [];
                            faceIds.push(this.onlyOneScreen);

                            // Un seul écran dans le parc du client, pas besoin de passer par la page du select screen
                            // this.onlyOneScreen contient le numéro IS de l'écran à sélectionner pour la finalisation de la campagne
                            this.campaigns$
                                .setFaces(result.diffusionId, faceIds)
                                .subscribe(() => {
                                    this.redirectToMainPage();
                                });
                        } else {
                            let url: string = `private-campaign/screens/${result.diffusionId
                                }?organizationId=${result.organizationId}&spotId=${this.controls.spotId.value
                                }&editMode=${item.id != null}`;

                            if (this.faceId != null) {
                                url += `&faceId=${this.faceId}`;
                            }

                            this.router.navigateByUrl(url);
                        }
                    } else {
                        let url: string = `private-campaign/screens/${result.diffusionId
                            }
							?organizationId=${result.organizationId}
							&editMode=${item.id != null}`;

                        if (this.faceId != null) {
                            url += `&faceId=${this.faceId}`;
                        }

                        this.router.navigateByUrl(url);
                    }
                } else {
                    this.alert.show({
                        message: 'Paramètres de diffusion modifiées !',
                        duration: 500,
                    });

                    this.redirectToMainPage();
                }

                this.loaded = true;
            },
            error: (err) => {
                this.waiting$.end(waitingId);
                this.alert.show({
                    message:
                        'Erreur lors de la modification de la diffusion ,veuillez vérifier les informations et réessayer.',
                });

                console.error(err);
                this.loaded = true;
            },
        });
    }

    goBack() {
        window.history.go(-1);
    }

    formatLabel(value: number) {
        if (value >= 1000) {
            return Math.round(value / 1000) + 'k';
        }

        return value;
    }

    isTodayNotInDates() {
        let newStart: Date = new Date(this.startReservation + 'Z');

        return newStart < this.today;
    }

    getCardIcon(periodTypeEnum: PerdiodTypeEnum): string {

        switch (periodTypeEnum) {
            case PerdiodTypeEnum.forTheDay:

                return 'today';
            case PerdiodTypeEnum.forTheWeek:
                return 'date_range';
            case PerdiodTypeEnum.Personalized:
                return 'edit_calendar';
            case PerdiodTypeEnum.Permanent:
                return 'all_inclusive';
            default:
                return 'calendar_today';
        }



    }
}
function provideMomentDateAdapter(MY_FORMATS: {
    parse: { dateInput: string };
    display: {
        dateInput: string;
        monthYearLabel: string;
        dateA11yLabel: string;
        monthYearA11yLabel: string;
    };
}): import('@angular/core').Provider {
    throw new Error('Function not implemented.');
}
